// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.beautybook.co.id/api/v1/',
  marketplaceUrl: 'https://beautybook.co.id/',
  'google-oauth2-client-id': '537128235967-qas1m762b4s89egeijgq994mqrcp93jd.apps.googleusercontent.com',
  'facebook-app-id': '339736504124701',
  'nicepay-imid': 'IONPAYTEST'
  // apiUrl: 'https://dev.api.beautybook.co.id/api/v1/',
  // marketplaceUrl: 'https://dev.beautybook.co.id/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
